import { Link } from 'react-router-dom';
import { projetos } from '../../../mocks/projetos';

export default function ProjetosDestaque() {
  const projetosDestaque = projetos.slice(0, 3);

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-6">Projeto em destaque</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça nosso projeto de construção residencial na Flórida, com acompanhamento transparente e foco em qualidade.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {projetosDestaque.map((projeto, index) => (
            <div
              key={projeto.id}
              className="bg-white border border-gray-200 rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={index === 0 
                    ? 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/f391eda3a0329cfc855b3af20cef968f.png'
                    : index === 1
                    ? 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/dcb38a566d4496e765f76dd519f23df6.png'
                    : projeto.imagem
                  }
                  alt={projeto.nome}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span
                    className={`px-4 py-2 rounded-full text-sm font-medium backdrop-blur-md ${
                      projeto.status === 'Oportunidade'
                        ? 'bg-blue-500/80 text-white'
                        : projeto.status === 'Único'
                        ? 'bg-green-500/80 text-white'
                        : 'bg-gold-500/80 text-gray-900'
                    }`}
                  >
                    {projeto.status}
                  </span>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-black mb-2">
                  {index === 0 ? 'Acabamentos Premium' : index === 1 ? 'Modelo Casa' : projeto.nome}
                </h3>
                <div className="flex items-center text-gray-600 mb-4">
                  <i className="ri-map-pin-line mr-2"></i>
                  <span>Citrus Spring, FL</span>
                </div>
                <p className="text-gray-700 leading-relaxed mb-6">
                  {index === 0 
                    ? 'Residências modernas de alto padrão com 4 quartos, e acabamento premium. Mercado muito aquecido.'
                    : index === 1
                    ? 'Área verde em uma cidade em franca expansão, aproximadamente 1h de Orlando.'
                    : 'Casas aconchegantes com design moderno e com grande interesse para primary home por americano.'
                  }
                </p>

                <div className="border-t border-gray-100 pt-6 mb-6 space-y-3">
                  <div className="flex items-center text-gray-700">
                    <i className="ri-time-line mr-2"></i>
                    <span className="font-medium">
                      {index === 0 ? 'De 9 a 11 meses' : index === 1 ? 'Até 11 meses até o retorno' : projeto.prazo}
                    </span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <i className="ri-money-dollar-circle-line mr-2"></i>
                    <span className="font-medium">
                      {index === 0 
                        ? 'A partir de $22,000' 
                        : index === 1 
                        ? 'Aproximadamente' 
                        : 'Retorno entre 14% a 18% aprox.'
                      }
                    </span>
                  </div>
                </div>

                <Link
                  to={`/projetos/${projeto.id}`}
                  className="block w-full py-3 border-2 border-black text-black text-center font-semibold rounded-lg hover:bg-black hover:text-white transition-all whitespace-nowrap"
                >
                  Ver detalhes completos
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/projetos"
            className="inline-block px-8 py-4 bg-black text-white font-semibold rounded-lg hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver todos os projetos
          </Link>
        </div>
      </div>
    </section>
  );
}
